export const STATUS_COLORS = {
  applied: { bg: 'rgba(30,104,255,0.08)', color: '#0076A3', label: 'Applied' },
  screening: { bg: 'rgba(245,158,11,0.08)', color: '#D97706', label: 'Screening' },
  interview: { bg: 'rgba(124,58,237,0.08)', color: '#0076A3', label: 'Interview' },
  offered: { bg: 'rgba(16,185,129,0.08)', color: '#059669', label: 'Offered' },
  rejected: { bg: 'rgba(239,68,68,0.08)', color: '#DC2626', label: 'Rejected' },
};

export const SKILL_CHIP = {
  padding: '0.1875rem 0.5rem', borderRadius: 999, background: 'rgba(30,104,255,0.08)',
  border: '1px solid rgba(30,104,255,0.15)', fontSize: '0.6875rem', color: '#0076A3',
};
